<template>
  <v-card
    light
    @click="$emit('click', customer)"
  >
    <b class="ellipsis mb-1">
      {{ customer.Nom }} {{ customer.Prenom }}
    </b>
    <div class="ml-2">
      {{ (customer.Mail && customer.Mail !== "") ? customer.Mail : "Mail non renseigné" }}<br>
      {{ (customer.Mobile && customer.Mobile !== "") ? customer.Mobile : customer.Telephone && customer.Telephone !== "" ? customer.Telephone : "N° de téléphone non renseigné" }}<br>
      {{ (customer.Adresse && customer.Adresse.Ville != null) ? customer.Adresse.Ville : "Ville non renseignée" }}
    </div>
  </v-card>
</template>

<script>
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'CustomerCard',

  props: {
    customer: { type: Object, required: true }
  },

  data () {
    return {
      IconEnum
    }
  },

  computed: {
    useFid () { return this.$store.getters.useFid }
  }
}
</script>
